import { Component, OnInit, AfterViewInit, ViewChild, Input, HostListener, inject, DestroyRef } from '@angular/core';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { AccountService } from 'src/app/services/account.service';
import { ResponsiveService } from 'src/app/services/responsive.service';
import { User, DefaultUser } from 'src/app/models/user.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SidenavService } from '../services/sidenav.service';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { RouterLink } from '@angular/router';
import { MatNavList } from '@angular/material/list';
import { LoginComponent } from '../login/login.component';

@Component({
    selector: 'app-hud',
    templateUrl: './hud.component.html',
    styleUrls: ['./hud.component.css'],
    animations: [
        trigger('toolbar-visibility', [
            state('toolbar-visible', style({
                top: '0px',
            })),
            state('toolbar-hidden', style({
                top: '-65px',
            })),
            state('logo-visible', style({
                opacity: '1.0',
            })),
            state('logo-hidden', style({
                opacity: '0.0',
            })),
            transition('toolbar-visible <=> toolbar-hidden', [
                animate('0.2s')
            ]),
            transition('logo-visible <=> logo-hidden', [
                animate('0.2s')
            ])
        ]),
    ],
    imports: [RouterLink, MatSidenavContainer, MatSidenav, MatNavList, LoginComponent]
})
export class HudComponent implements OnInit, AfterViewInit {

  private account = inject(AccountService);
  private sidenavService = inject(SidenavService);
  private destroyRef = inject(DestroyRef);
  responsiveService = inject(ResponsiveService);

  user: User;
  opened = false;
  openedbymouse = false;
  toolbarVisible = true;
  @ViewChild('sidenav', { static: true }) sidenav: MatSidenav;
  scrollPosition: number;
  @Input()
  displaySocialLinks = true;
  ToggleNav = true;
  // TODO: Replace _getWidth() private API access with a proper width measurement
  sidenavWidth = 250;

  ngOnInit(): void {
    this.scrollPosition = 0;
    this.sidenav.fixedTopGap = 0;
    this.initializeUser();
    this.sidenavService.opened
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: _ => this.opened = _,
      })
    this.sidenavService.openedbymouse
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: _ => this.openedbymouse = _,
      })
  }

  ngAfterViewInit(): void {
    this.sidenavService.setSidenav(this.sidenav);
    this.sidenavWidth = this.sidenav._getWidth() || 250;
  }

  initializeUser() {
    this.user = DefaultUser
    this.account.userObservable
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (next: User) => {
          if (next != null)
            this.user = next;
          else
            this.user = DefaultUser
        }
      )
  }

  toggleSidenav() {
    this.sidenavService.toggle();
  }

  CollapseLogo() {
    this.ToggleNav = !this.ToggleNav;
  }

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(event) {
    if (!this.sidenav) return;
    if (event.clientX < window.innerWidth * .05 + this.sidenavWidth * +!!this.openedbymouse) { this.sidenavService.setOpenedbymouse(true);}
    else { this.sidenavService.setOpenedbymouse(false);}
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(_event) {
    if (!this.responsiveService.isMobile())
      this.toolbarVisible = this.scrollPosition > window.scrollY || window.scrollY == 0;
    this.scrollPosition = window.scrollY;
  }

}
